import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
import * as tracking from '../util/tracking';

const hits = 3;

export const recentSearchesSearchPlugin =
  createLocalStorageRecentSearchesPlugin({
    key: 'CatalogSearch_RecentSearches',
    limit: hits,
    transformSource({ source, onRemove, onTapAhead }) {
      return {
        ...source,
        getItemUrl({ item }) {
          return `/catalog/search?query=${item.label}`;
        },
        templates: {
          ...source.templates,
          item({ item, createElement, components }) {
            let url = `/catalog/search/?query=${encodeURIComponent(
              item.label
            )}`;
            return createElement(
              'a',
              {
                class: 'catalog-search-item',
                href: url,
                onClick(event) {
                  event.preventDefault();
                  tracking.trackEvent(
                    'CatalogSearch',
                    'ManualSearch',
                    item.label
                  );
                  setTimeout(function () {
                    window.location.href = url;
                  }, 50);
                },
              },
              // Icon
              createElement('span', {
                class: 'icon',
                dangerouslySetInnerHTML: {
                  __html: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5" stroke="black"/><path d="M8 3V8L11.5 10.5" stroke="black" stroke-linecap="round"/></svg>`,
                },
              }),
              // Content
              createElement(
                'span',
                {
                  class: 'content',
                },
                components.Highlight({
                  hit: item,
                  attribute: 'label',
                  tagName: 'mark',
                })
              ),
              // Action icons
              createElement(
                'span',
                {
                  class: 'actions',
                },
                // Remove button
                createElement('span', {
                  title: `${window.i18n.header.searchRemoveTitle} '${item.label}'`,
                  onClick: event => {
                    event.preventDefault();
                    event.stopPropagation();
                    onRemove(item.id);
                  },
                  dangerouslySetInnerHTML: {
                    __html: `<svg width="14" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16"><path stroke="#000" d="M2.5 3h9v12h-9z"/><path d="M1 3h12M4.5 3c0-.5 0-2 1.5-2h2c1.5 0 1.5 1.5 1.5 2M5.5 6.5v5m3-5v5" stroke="#000" stroke-linecap="round"/></svg>`,
                  },
                }),
                // Auto fill button
                createElement('span', {
                  title: `${window.i18n.header.searchAutofillTitle} '${item.label}'`,
                  onClick: event => {
                    event.preventDefault();
                    event.stopPropagation();
                    onTapAhead(item);
                  },
                  dangerouslySetInnerHTML: {
                    __html: `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11V1M1 1H11M1 1L12 12" stroke="black" stroke-linecap="round"/></svg>`,
                  },
                })
              )
            );
          },
        },
      };
    },
  });
